var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"generating-indicator"},[_c('div',{staticClass:"generating-indicator__item"}),_c('div',{staticClass:"generating-indicator__item"}),_c('div',{staticClass:"generating-indicator__item"})])}]

export { render, staticRenderFns }